export default (courses) => {
    return 1;
  };
  